import React from 'react';
import './Header.css';

function fmt(n) {
  if (n >= 1000000) return '€' + (n / 1000000).toFixed(2) + 'M';
  if (n >= 1000) return '€' + Math.round(n / 1000) + 'K';
  return '€' + n.toLocaleString('es-ES');
}

function Header({ projects, lastUpdate, hsLoading = false }) {
  const calculateMetrics = () => {
    let pagadas = 0;
    let collected = 0;
    let refundPending = 0;
    let cobrosSinId = 3; // mock: 3 cobros sin ID en BC

    projects.forEach(project => {
      pagadas += project.arrasPageadas || project.paid || 0;
      collected += project.collected || 0;
      refundPending += project.refundPending || 0;
    });

    return { pagadas, collected, netPosition: pagadas - collected, refundPending, cobrosSinId };
  };

  const m = calculateMetrics();
  const secsAgo = Math.floor((Date.now() - lastUpdate) / 1000);
  const timeLabel = secsAgo < 120 ? `hace ${secsAgo}s` : `hace ${Math.floor(secsAgo / 60)} min`;

  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <svg width="28" height="28" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="15" y="10" width="48" height="22" rx="7" transform="rotate(-8 15 10)" fill="#3b5bff"/>
          <rect x="12" y="48" width="22" height="42" rx="7" fill="#3b5bff"/>
          <rect x="42" y="38" width="22" height="48" rx="7" transform="rotate(-20 42 38)" fill="#3b5bff"/>
        </svg>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div className="logo" style={{ color: 'var(--tx)' }}>Arras Live</div>
            <span style={{ fontSize: 11, fontWeight: 400, color: 'var(--tx3)', letterSpacing: '.2px' }}>by Prophero</span>
          </div>
          <div className="sub">Actualizado {timeLabel} · Vistral + Business Central</div>
        </div>
      </div>
      <div className="sp"></div>
      {m.refundPending > 0 && (
        <span className="badge by">
          <i className="ti ti-clock" style={{ fontSize: 10 }}></i>
          {fmt(m.refundPending)} señal pendiente refund
        </span>
      )}
      {m.cobrosSinId > 0 && (
        <span className="badge br">
          <i className="ti ti-alert-triangle" style={{ fontSize: 10 }}></i>
          {m.cobrosSinId} cobros sin ID
        </span>
      )}

      <div className="metrics">
        <div className="mc">
          <div className="ml">Arras pagadas (supply → vendedor)</div>
          {hsLoading ? (
            <div className="mv-loading">
              <span className="mv-spinner" />
              <span className="mv-loading-text">Cargando…</span>
            </div>
          ) : (
            <div className="mv" style={{ color: 'var(--rt)' }}>−{fmt(m.pagadas)}</div>
          )}
          <div className="mh">suma de pagos a vendedores</div>
        </div>
        <div className="mc">
          <div className="ml">Arras collected (clientes)</div>
          {hsLoading ? (
            <div className="mv-loading">
              <span className="mv-spinner" />
              <span className="mv-loading-text">Cargando…</span>
            </div>
          ) : (
            <div className="mv" style={{ color: 'var(--gt)' }}>+{fmt(m.collected)}</div>
          )}
          <div className="mh">cobros reales en BC · to be coll. + señal</div>
        </div>
        <div className="mc">
          <div className="ml">Posición neta</div>
          {hsLoading ? (
            <div className="mv-loading">
              <span className="mv-spinner" />
              <span className="mv-loading-text">Cargando…</span>
            </div>
          ) : (
            <div className="mv" style={{ color: 'var(--rt)' }}>−{fmt(m.netPosition)}</div>
          )}
          <div className="mh">arras pagadas − arras collected</div>
        </div>
      </div>
    </div>
  );
}

export default Header;
